export default [
  { path: '/guide/manage', name: 'GuidManage', component: () => import(/* webpackChunkName: "guide-manage" */ './index.vue') }
]